import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapsLoader from 'google-maps';
import classnames from 'classnames';
import mapStyles from '@chama/statics/stylesheets/map-style.json';

import fitBounds from './methods/fitBounds';
import { redrawPolylines } from './methods/handlePolylines';
import handleEvents from './methods/handleEvents';
import defaultStyleMap from './methods/styleMap';
import addToHistory from './methods/handleHistory';

import './Map.css';

export default class Map extends React.Component {
  constructor(props) {
    super(props);

    this.fitBounds = fitBounds.bind(this);
    this.redrawPolylines = redrawPolylines.bind(this);
    this.handleEvents = handleEvents.bind(this);
    this.addToHistory = addToHistory.bind(this);

    this.google = null;
    this.map = null;
    this.polylines = [];
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    const { googleMapsApiKey } = this.props;
    GoogleMapsLoader.KEY = googleMapsApiKey;
    // provides "google" object to CB function
    GoogleMapsLoader.load(this.init);
  }

  componentWillUnmount() {
    // do not call GoogleMapsLoader.release() as it will mess up with other pages using map
    // as releasing causes the component to delete `window.google`
  }

  componentDidUpdate(prevProps) {
    const { editPolygonMode, dragPolygonMode } = this.props;
    if (
      editPolygonMode !== prevProps.editPolygonMode ||
      dragPolygonMode !== prevProps.dragPolygonMode
    ) {
      this.styleMap();
      this.redrawPolylines();
    }
    this.draw(true);
  }

  init = google => {
    this.google = google;

    // Initializing google maps
    this.map = new google.maps.Map(this.mapRef.current, {
      styles: mapStyles.styles,
      mapTypeControl: false,
      fullscreenControl: false,
    });

    // Attach events to map's data layer
    this.handleEvents();

    // draw the map
    this.draw();
  };

  styleMap = () => {
    const applyStyles = this.props.styleMap || defaultStyleMap;
    applyStyles.call(this);
  };

  draw = clear => {
    const { data, boundsFit, onFitBounds } = this.props;

    if (!this.map) return;

    // Clearing existing map
    if (clear) this.map.data.forEach(feature => this.map.data.remove(feature));
    // Adding geoJson
    this.map.data.addGeoJson(data);
    // Fitting bounds only once for each set of data
    if (!boundsFit) {
      this.fitBounds();
      onFitBounds(true);
    }
    // Drawing polylines
    this.redrawPolylines();
    // Apply styles
    this.styleMap();
  };

  render() {
    const { className } = this.props;
    return <div className={classnames('CoverageAreaMap__map', className)} ref={this.mapRef} />;
  }
}

/* eslint-disable react/no-unused-prop-types */
Map.propTypes = {
  className: PropTypes.string,
  googleMapsApiKey: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  editPolygonMode: PropTypes.bool,
  dragPolygonMode: PropTypes.bool,
  addPolygonMode: PropTypes.bool,
  deletePolygonMode: PropTypes.bool,
  onAddToHistory: PropTypes.func,
  boundsFit: PropTypes.bool,
  onFitBounds: PropTypes.func,
  styleMap: PropTypes.func,
};
Map.defaultProps = {
  className: '',
  onAddToHistory: Function.prototype,
  onFitBounds: Function.prototype,
  editPolygonMode: false,
  dragPolygonMode: false,
  addPolygonMode: false,
  deletePolygonMode: false,
  boundsFit: false,
  styleMap: null,
};
/* eslint-enable react/no-unused-prop-types */



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/Map.jsx